// extracted by mini-css-extract-plugin
var _1 = "TopicDetailPreview-module__actionButton--DuVYd";
var _2 = "TopicDetailPreview-module__amount--Pukif";
var _3 = "TopicDetailPreview-module__animateUploadProgressBarWidth--w8Wnc";
var _4 = "TopicDetailPreview-module__animatedBackground--GWtwW";
var _5 = "TopicDetailPreview-module__banner--kzK_8";
var _6 = "120px";
var _7 = "TopicDetailPreview-module__container--URHk8";
var _8 = "TopicDetailPreview-module__content--LLOZF";
var _9 = "TopicDetailPreview-module__contentContainer--SClyp";
var _a = "TopicDetailPreview-module__editorRoot--Cqwoz";
var _b = "TopicDetailPreview-module__footer--aVUVI";
var _c = "TopicDetailPreview-module__header--UOxqp";
var _d = "TopicDetailPreview-module__headerContainer--auesj";
var _e = "TopicDetailPreview-module__overlayLink--HxRkj";
var _f = "TopicDetailPreview-module__posts--xpqRu";
var _10 = "TopicDetailPreview-module__postsIcon--RHHc3";
var _11 = "TopicDetailPreview-module__subtopics--K_VD5";
var _12 = "TopicDetailPreview-module__subtopicsIcon--F43_p";
var _13 = "TopicDetailPreview-module__templates--K1RfE";
var _14 = "TopicDetailPreview-module__templatesIcon--gNPf8";
export { _1 as "actionButton", _2 as "amount", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "banner", _6 as "bannerHeight", _7 as "container", _8 as "content", _9 as "contentContainer", _a as "editorRoot", _b as "footer", _c as "header", _d as "headerContainer", _e as "overlayLink", _f as "posts", _10 as "postsIcon", _11 as "subtopics", _12 as "subtopicsIcon", _13 as "templates", _14 as "templatesIcon" }
